import {WidgetState} from "@/apps/StudentExchangeOverviewWidget/models/store-viewmodel"
import actions from "@/apps/StudentExchangeOverviewWidget/store/actions"
import mutations from "@/apps/StudentExchangeOverviewWidget/store/mutations"
import getters from "@/apps/StudentExchangeOverviewWidget/store/getters"

export default {
    state: new WidgetState,
    actions: actions,
    mutations: mutations,
    getters: getters
}